import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Navbar.css';

function Navbar() {
  return (
    <nav className="navbar">
      <div className="logo">
        <Link to="/">Nomondoru's Tech Blogs</Link>
      </div>
      <input type="checkbox" id="nav-toggle" className="nav-toggle" />
      <label htmlFor="nav-toggle" className="burger">
        <span></span>
        <span></span>
        <span></span>
      </label>
      <ul className="nav-menu">
        <li><Link to="/"><i className="fas fa-home"></i> Home</Link></li>
        <li><Link to="/articles"><i className="fas fa-pen-nib"></i> Articles</Link></li>
      </ul>
    </nav>
  );
}

export default Navbar;
